export const EMAIL = "Emiraresponds@gmail.com";
export const MAILTO = `mailto:${EMAIL}`;
